import angular from 'angular';

angular.module('cloudX').directive('cxTimeInputXedit', function() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function(scope, el, attrs, ngModel) {
      if (!ngModel) return;
      var unit = (attrs.cxTimeInputXedit || 'm').substring(0, 1).toLowerCase(); //m or h
      if (unit !== 'm' && unit !== 'h') unit = 'm';

      var max =
        (scope.$eval(attrs.max) || (unit === 'm' ? 1439 : 1439 / 60.0)) * (unit === 'm' ? 1 : 60.0); //Default 23:59

      ngModel.$formatters.push(function(value) {
        if (value === null || isNaN(value)) return null;
        var minute = 0;
        var hour = 0;
        var sign = value < 0 ? '-' : '';
        value = Math.abs(value);
        if (unit === 'm') {
          minute = value % 60;
          hour = Math.floor((value - minute) / 60.0);
        } else if (unit === 'h') {
          minute = Math.round(value * 60) % 60;
          hour = Math.floor(value);
        }
        return sign + (hour < 10 ? '0' : '') + hour + ':' + (minute < 10 ? '0' : '') + minute;
      });
      ngModel.$parsers.push(function(value) {
        if (!value) return null;
        var factor = 1;
        if (value[0] === '-') {
          factor = -1;
          value = value.substring(1);
        }
        var split = value.split(':');
        var hour = 0;
        var minute = 0;
        if (split.length === 2) {
          hour = parseInt(split[0]);
        }
        minute = parseInt(split[split.length - 1]);
        var totalMinutes = Math.abs(hour || 0) * 60 + (minute || 0);
        if (totalMinutes > max) totalMinutes = max; //Default 23:59
        if (unit === 'h') return (factor * totalMinutes) / 60.0;
        return factor * totalMinutes;
      });
    },
  };
});
